import { APP_DEFAULT_LANGUAGE_KEY, LANGUAGE_SELECT } from 'config';
import { localStorageManager } from 'services/localStorage';

const currentLanguage = localStorageManager.getCurrentLanguage();
export const findLanguageEntity = (check: string) =>
  LANGUAGE_SELECT.find(({ keyLanguage }) => keyLanguage === check);

export const currentLanguageEntity = findLanguageEntity(
  currentLanguage || APP_DEFAULT_LANGUAGE_KEY,
);
